import axios from "axios";
import { Message as ElMessage } from "element-ui";
export const CancelToken = axios.CancelToken;

//获取rest api相关
function getRestPromise(url, params, method, config) {
  return new Promise((resolve, reject) => {
    axios[method](url, params, config)
      .then(async (response) => {
        if (response && response.code === 200) {
          resolve(response.result);
        } else {
            reject(response)
          // 后台服务启动异常
        //   if (!response) {
        //     reject(response.data || "api report error");
        //     return;
        //   }
        //   // 文件删除等错误特殊处理
        //   if (response && response.data && response.data.errorStatus) {
        //     reject(response.data || "api report error");
        //     return;
        //   }
        //   const message =
        //     response && response.message
        //       ? response.message
        //       : "api report error";
        //   ElMessage.error(message);
        //   reject(response || "api report error");
        }
      })
      .catch((e) => {
        console.log("catch ====", e);
        if (axios.isCancel(e)) {
        } else {
          reject();
        }
      });
  });
}

// 添加请求拦截器
axios.interceptors.request.use(
  (request) => {
    request.baseURL = window._CONFIG.ajaxBaseUrlBI;
    return request;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    return response.data;
  },
  (error) => {
    // 对响应错误做点什么
    // if (error.message.indexOf('timeout') != -1) {
    //   ElMessage.error('网络超时');
    // } else if (error.message == 'Network Error') {
    //   ElMessage.error('网络连接错误');
    // } else {
    //   if (error.response.data) ElMessage.error(error.response.statusText);
    //   else ElMessage.error('接口路径找不到');
    // }
    // return Promise.reject(error);
  }
);
export function genRequestLogHeader(request, params) {
	if (params.hasOwnProperty('bname')) {
		// console.log(params);
		request.headers[MDZY_LOG_HEADER_NANE] = encodeURIComponent(
			JSON.stringify({
				bname: params.bname + (params.bsuffix ? '.' + params.bsuffix : ''),
				bid: params.bid,
				bmodule: params.bmodule,
				operationType: params.operationType,
				content: params.content,
			})
		)
		return true
	}
	return false
}
const get = function (url, params, responseType) {
  return getRestPromise(
    url,
    { params: params, responseType: responseType ?? "json" },
    "get"
  );
};
const del = function (url, params) {
  return getRestPromise(url, { params: params }, "delete");
};
const post = function (
  url,
  params,
  timeout,
  responseType,
  customHeader,
  cancelToken
) {
  let config = {
    timeout: timeout ?? 30000,
    responseType: responseType ?? "json",
  };
  if (cancelToken) {
    config.cancelToken = cancelToken;
  }
  return getRestPromise(url, params, "post", config);
};
const put = function (url, params) {
  return getRestPromise(url, params, "put");
};
/* const ajax = {
  get: get,
  del: del,
  post: post,
  put: put,
}; */
// 导出 axios 实例
// export default ajax
export const ajax = {
  get: get,
  del: del,
  post: post,
  put: put,
};
